<template>
  <form class="topform" @submit.prevent="addPromotion()">
    <input
      type="radio"
      id="ORDER_DISCOUNT"
      value="ORDER_DISCOUNT"
      v-model="type"
    />
    <label for="ORDER_DISCOUNT">Zniżka procentowa</label>
    <br />
    <input type="radio" id="WALLET_MONEY" value="WALLET_MONEY" v-model="type" />
    <label for="WALLET_MONEY">Zniżka na zamówienie w zł</label>
    <br />
    <div class="input-container" style="margin-top: 30px">
      <label>Kod promocyjny</label>
      <input
        v-model="code"
        id="title"
        type="text"
        class="form-control"
        required
        minlength="6"
        maxlength="12"
      />
    </div>
    <div>
      <label v-if="type === 'WALLET_MONEY'">Wartość podana w zł</label>
      <label v-if="type === 'ORDER_DISCOUNT'">Wartość podana w %</label>
      <input
        v-if="type === 'WALLET_MONEY'"
        v-model="value"
        id="title"
        type="number"
        class="form-control"
        required
        min="1"
      />
      <input
        v-if="type === 'ORDER_DISCOUNT'"
        v-model="value"
        id="title"
        type="number"
        class="form-control"
        required
        min="1"
        max="99"
      />
    </div>

    <div class="mt-3">
      <label>Data wygaśnięcia promocji</label>
    </div>
    <div class="datepickers">
      <datepicker
        :monday-first="true"
        :language="pl"
        v-model="expiration_date"
        name="expiration_date"
        :placeholder="'Wybierz datę'"
        required
      ></datepicker>
    </div>
    <button style="width:300px;" class="btn btn-outline-dark" type="submit">
      Zapisz
    </button>
  </form>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { pl } from "vuejs-datepicker/dist/locale";
import shared from "@/shared";
import axios from "@/axios";
export default {
  components: { Datepicker },
  emits: ["refresh", "justAddedCode"],
  data() {
    return {
      pl: pl,
      code: "",
      value: "",
      type: "ORDER_DISCOUNT",
      expiration_date: "",
      edittedDate: "",
      filter: null,
    };
  },
  created() {
    this.isFuture = shared.isFuture;
  },
  methods: {
    addPromotion() {
      const date = new Date(this.expiration_date);
      if (!this.expiration_date) {
        return this.$notify({
          group: "error",
          text: "Wybierz datę ważności kodu",
        });
      }
      if (!this.isFuture(this.expiration_date)) {
        return this.$notify({
          group: "error",
          text: "Wybierz prawidłową datę ważności",
        });
      }
      let valueToSet = this.value;
      if (this.type === "ORDER_DISCOUNT") {
        valueToSet = this.value / 100;
      }
      axios
        .post(`/api/promotionalCode`, {
          type: this.type,
          value: valueToSet,
          code: this.code,
          expiration_date: date.getTime() / 1000,
        })
        .then(() => {
          this.$notify({
            group: "success",
            text: "Kod został dodany",
          });
          this.$emit("refresh");
          this.$emit("justAddedCode", this.code);
          this.value = "";
          this.code = "";
          this.expiration_date = "";
        })
        .catch((err) => {
          console.log(err.response);
          if (err.response.data[0].error === "code_already_exist") {
            this.$notify({
              group: "error",
              text: "Taki kod już istnieje",
            });
          }
        });
    },
  },
};
</script>
